import SearchMolecule, {
  GButtonBoxCum,
  GInputArea,
  ItemWrap,
  SearchItemWrap,
  SearchWrap,
  UnHiddenSearchWrap,
} from 'components/common/SearchMolecule';
import dayjs from 'dayjs';
import GButtonLayout from 'components/molecule/GbuttonLayout';
import { GButton } from 'components/atom/button';
import RecycleB from 'components/asset/images/RecycleB.svg';
import searchImage from 'components/asset/images/Search.svg';
import { useTranslation } from 'react-i18next';
import { ReqMemberVO } from './MemberHistoryPage';
import { CommonCode } from 'models/admin/CommonCode';
import { GLabelAtom } from 'components/atom/label';
import GSelectMUIAtom from 'components/common/select/GSelectMUIAtom';
import { SelectChangeEvent } from '@mui/material/Select';

interface Props {
  searchParams: ReqMemberVO;
  setSearchParams: (param: ReqMemberVO) => void;
  search: (isPage: boolean, condition: ReqMemberVO) => void;
  statCdList: CommonCode[];
}
const SearchArea = ({ searchParams, setSearchParams, search, statCdList }: Props) => {
  //
  const { t } = useTranslation();

  const handleClickSearchParamInit = () => {
    setSearchParams({
      soprMgrNm: '',
      vdcpNm: '',
      vdcpErpNm: '',
      vdcpCd: '',
      vdcpMgrNm: '',
      vdcpMgrEmal: '',
      soprMgrCopCd: '',
      dataInsDtm: '',
      regReqDt: '',
      regReqDtSt: '',
      regReqDtEnd: '',
      mbrPsgStatCd: '',
      dataInsUserNm: '',
    });
  };

  const handleChangeSearchParams = (e, id) => {
    console.log('아이디 : ', id, e.target.value);
    setSearchParams({ ...searchParams, [id]: e.target.value });
  };

  const handleClickSearch = () => {
    console.log('조회', searchParams);
    search(false, searchParams);
  };

  const handleCrtDateChange = (newDate, id) => {
    handleDateRangeChange(newDate, id, 'regReqDt', 'YYYYMMDD');
  };

  const handleDateRangeChange = (newDate, id, key, format) => {
    const newParams = {};
    if (id === 'end') {
      newParams[key + 'End'] = newDate.format(format);

      if (searchParams[key + 'St'] === '' || newDate.isBefore(dayjs(searchParams[key + 'St'])))
        newParams[key + 'St'] = newDate.format(format);

      setSearchParams({ ...searchParams, ...newParams });
    } else if (id === 'start') {
      newParams[key + 'St'] = newDate.format(format);

      if (searchParams[key + 'End'] === '' || newDate.isAfter(dayjs(searchParams[key + 'End'])))
        newParams[key + 'End'] = newDate.format(format);

      setSearchParams({ ...searchParams, ...newParams });
    }
  };

  function handleSelectChange(e: SelectChangeEvent<string>) {
    if (e !== null) {
      setSearchParams({ ...searchParams, mbrPsgStatCd: e.target?.value });
    }
  }

  return (
    <>
      <SearchWrap>
        <UnHiddenSearchWrap>
          <SearchItemWrap>
            <SearchMolecule
              labelTitle={t('Vendor ID', 'Vendor ID')}
              searchWidth="50%"
              searchValueWidth="300px"
              type="input"
              textInputValue={searchParams.vdcpCd}
              placeholder={t('com.label.00016', '__Vendor ID를 입력하세요')}
              onChange={(e) => {
                handleChangeSearchParams(e, 'vdcpCd');
              }}
              onKeyUp={(e) => {
                if (e.key === 'Enter') handleClickSearch();
              }}
            />
            <GInputArea searchWidth="33%">
              <GLabelAtom labelWidth="120px">{t('com.label.00506', '처리상태')}</GLabelAtom>
              <ItemWrap searchValueWidth="380px">
                <GSelectMUIAtom
                  status="default"
                  // selectWidth="350px"
                  option={statCdList}
                  placeholder={t('com.label.00023', '__선택') ?? ''}
                  codeKey="cmnCd"
                  // codeName="cmnCdDesc"
                  codeName="cmnCdNm"
                  value={searchParams.mbrPsgStatCd}
                  handleChange={handleSelectChange}
                />
              </ItemWrap>
            </GInputArea>
            <SearchMolecule
              labelTitle={`${t('com.label.00017', '업체명')}(ERP)`}
              searchWidth="50%"
              searchValueWidth="300px"
              type="input"
              textInputValue={searchParams.vdcpErpNm}
              placeholder={t('com.label.00513', '__업체명(ERP)를 입력하세요')}
              onChange={(e) => {
                handleChangeSearchParams(e, 'vdcpErpNm');
              }}
              onKeyUp={(e) => {
                if (e.key === 'Enter') handleClickSearch();
              }}
            />
            <SearchMolecule
              labelTitle={`${t('com.label.00017', '업체명')}(${t('com.label.00514', '거래처')})`}
              searchWidth="50%"
              searchValueWidth="300px"
              type="input"
              textInputValue={searchParams.vdcpNm}
              placeholder={t('com.label.00512', '__업체명(거래처)를 입력하세요')}
              onChange={(e) => {
                handleChangeSearchParams(e, 'vdcpNm');
              }}
              onKeyUp={(e) => {
                if (e.key === 'Enter') handleClickSearch();
              }}
            />
            <SearchMolecule
              labelTitle={t('com.label.00096', '법인코드')}
              searchWidth="50%"
              searchValueWidth="300px"
              type="input"
              textInputValue={searchParams.soprMgrCopCd}
              placeholder={t('com.label.00801', '__법인코드를 입력하세요')}
              onChange={(e) => {
                handleChangeSearchParams(e, 'soprMgrCopCd');
              }}
              onKeyUp={(e) => {
                if (e.key === 'Enter') handleClickSearch();
              }}
            />
            <SearchMolecule
              labelTitle={t('com.label.00095', '담당자')}
              searchWidth="50%"
              searchValueWidth="300px"
              type="input"
              textInputValue={searchParams.soprMgrNm}
              placeholder={t('com.label.00566', '__담당자를 입력하세요')}
              onChange={(e) => {
                handleChangeSearchParams(e, 'soprMgrNm');
              }}
              onKeyUp={(e) => {
                if (e.key === 'Enter') handleClickSearch();
              }}
            />
            <SearchMolecule
              labelTitle={t('com.label.00090', '이메일')}
              searchWidth="50%"
              searchValueWidth="300px"
              type="input"
              textInputValue={searchParams.vdcpMgrEmal}
              placeholder={t('com.label.00800', '__이메일을 입력하세요')}
              onChange={(e) => {
                handleChangeSearchParams(e, 'vdcpMgrEmal');
              }}
              onKeyUp={(e) => {
                if (e.key === 'Enter') handleClickSearch();
              }}
            />
            <SearchMolecule
              type="calendar"
              labelTitle={t('com.label.reqDtm', '__요청일시')}
              calendarDouble={true}
              calendarFormat="YYYY.MM.DD"
              calendarViews={['year', 'month', 'day']}
              calendarMaxWidth="128px"
              startDate={dayjs(searchParams.regReqDtSt)}
              endDate={dayjs(searchParams.regReqDtEnd)}
              onChange={handleCrtDateChange}
              mindate={'2001.01.01'}
              maxdate={`${String(Number(new Date().getFullYear()) + 20)}.01.01`}
            />
            <SearchMolecule
              labelTitle={t('com.label.upus', '수정자')}
              searchWidth="50%"
              searchValueWidth="300px"
              type="input"
              textInputValue={searchParams.dataInsUserNm}
              placeholder={t('com.label.mgt.upus', '__수정자를 입력하세요')}
              onChange={(e) => {
                handleChangeSearchParams(e, 'dataInsUserNm');
              }}
              onKeyUp={(e) => {
                if (e.key === 'Enter') handleClickSearch();
              }}
            />
          </SearchItemWrap>
          <GButtonLayout marginBottom="0px">
            <GButtonBoxCum>
              <GButton
                chkImg={RecycleB}
                sizes="medium"
                btnstyled="outline"
                btnColor="normal"
                hasImg={true}
                hasTxt={false}
                onClick={handleClickSearchParamInit}
              ></GButton>
              <GButton
                chkImg={searchImage}
                txt={t('com.label.00116', '조회')}
                sizes="medium"
                btnstyled="contained"
                btnColor="normal"
                hasImg={true}
                hasTxt={true}
                onClick={handleClickSearch}
              ></GButton>
            </GButtonBoxCum>
          </GButtonLayout>
        </UnHiddenSearchWrap>
      </SearchWrap>
    </>
  );
};
export default SearchArea;
